import React from 'react';
import { StyleCard } from './style/StyleCard';

const Card = (props) => {
	const {
        icon,
        altIcon,
        titleIcon,
        title,
        subtitle,
        children,
        classButton,
        textButton,
        linkButton,
        eventButton,
        classComponent,
        targetButton,
        padding,
		contentMargin,
		boxShadow,
	} = props;

	return (
		<StyleCard
			className={classComponent}
			padding={padding}
			contentMargin={contentMargin}
			boxShadow={boxShadow}
		>
			<div className="content-header">
				<img src={icon} alt={altIcon} title={titleIcon} className="icon" />
				<h4>{title}</h4>
			</div>
			<h5>{subtitle}</h5>
			<div className="content-body">{children}</div>
			<a href={linkButton} rel="noopener noreferrer" target={targetButton} className={classButton} onClick={eventButton}>{textButton}</a>
		</StyleCard>
	);
};

export default Card;
